import {Component, Inject, OnInit} from '@angular/core';
import {PatientService} from '../../modules/patient/patient.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToothSelectorResponseModel} from './models/tooth-selector-response.model';

@Component({
  selector: 'app-tdo-tooth-selector-dialog',
  templateUrl: './tdo-tooth-selector-dialog.component.html',
  styleUrls: ['./tdo-tooth-selector-dialog.component.scss']
})
export class TdoToothSelectorDialogComponent implements OnInit {
  casesTeeth: ToothSelectorResponseModel[] = [];
  selectedCaseTeeth: ToothSelectorResponseModel;

  constructor(private patientService: PatientService,
              private dialogRef: MatDialogRef<TdoToothSelectorDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any) { }

  ngOnInit(): void {
    this.patientService.getAllPatientCasesAndTeeth(this.data.patientId).subscribe((res) => {
      this.casesTeeth = res;
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.selectedCaseTeeth);
  }

  getDate(date: string) {
    return new Date(date).toDateString();
  }

  isSelectedItem(ct: ToothSelectorResponseModel) {
    return ct === this.selectedCaseTeeth;
  }

  onCaseTeethClick(ct: ToothSelectorResponseModel) {
    this.selectedCaseTeeth = ct;
  }
}
